(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var threshold = (window.RIWAYAT && window.RIWAYAT.freeShippingThreshold) || 75;

  function parseMoney(text) {
    if (!text) return 0;
    var cleaned = text.replace(/[^0-9.,]/g, '').replace(/,(?=\d{3}(\D|$))/g, '');
    var normalized = cleaned.indexOf(',') > -1 && cleaned.indexOf('.') === -1 ? cleaned.replace(',', '.') : cleaned;
    var value = parseFloat(normalized);
    return isNaN(value) ? 0 : value;
  }

  function updateFill() {
    var drawer = document.getElementById('cart-drawer');
    var totalEl = document.querySelector('#cart-drawer [data-testid="cart-total-value"]');
    if (!drawer || !totalEl) return;
    var total = parseMoney(totalEl.textContent);
    var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
    drawer.style.setProperty('--riwayat-cart-fill', pct + '%');
  }

  var drawerRoot = document.getElementById('cart-drawer');
  if (drawerRoot) {
    if (!drawerRoot.querySelector('.riwayat-cart-fill')) {
      var fill = document.createElement('div');
      fill.className = 'riwayat-cart-fill';
      fill.setAttribute('aria-hidden', 'true');
      drawerRoot.prepend(fill);
    }
    updateFill();
    new MutationObserver(updateFill).observe(drawerRoot, { childList: true, subtree: true, characterData: true });
  }

  if (reducedMotion) return;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(form.action)) return;

    var submitter = e.submitter || form.querySelector('[type="submit"]');
    var cartTarget = document.querySelector('#cart-icon-bubble, [id^="cart-icon"], a[href="/cart"], a[href*="#cart-drawer"]');
    if (!submitter || !cartTarget) return;

    var startRect = submitter.getBoundingClientRect();
    var endRect = cartTarget.getBoundingClientRect();

    var drop = document.createElement('div');
    drop.setAttribute('aria-hidden', 'true');
    drop.style.cssText =
      'position:fixed;z-index:2147483000;width:10px;height:14px;border-radius:50% 50% 50% 60%;' +
      'background:radial-gradient(circle at 35% 30%, #D8B76A, #B99650 75%);pointer-events:none;' +
      'left:' + (startRect.left + startRect.width / 2) + 'px;top:' + (startRect.top + startRect.height / 2) + 'px;';
    document.body.appendChild(drop);

    var animation = drop.animate(
      [
        { transform: 'translate(-50%, -50%) scale(1)', opacity: 1, offset: 0 },
        {
          transform:
            'translate(' +
            (endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2) - 5) +
            'px, ' +
            (endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2) - 7) +
            'px) scale(0.4)',
          opacity: 0.3,
          offset: 1,
        },
      ],
      { duration: 550, easing: 'cubic-bezier(0.65,0,0.35,1)' }
    );

    animation.onfinish = function () {
      drop.remove();
    };

    if (window.riwayatPlayDrop) window.riwayatPlayDrop();
  });
})();
